import React, { PropTypes } from 'react';
import styled from 'styled-components';

import ButtonIcognito from '../../../../components/common/ButtonIcognito';
import LeaseIndicator from './LeaseIndicator';

const Card = styled(ButtonIcognito)`
  height: 100%;
  text-align: center;
  width: 100%;
`;

const CardMetricLease = ({
  onClick,
  ElapsedTerm,
  Term,
}) => {
  return (
    <Card onClick={onClick}>
      <LeaseIndicator
        current={ElapsedTerm}
        total={Term}
      />
    </Card>
  );
};

CardMetricLease.propTypes = {
  ElapsedTerm: PropTypes.number,
  Term: PropTypes.number,
  onClick: PropTypes.func,
};

export default CardMetricLease;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ProfileTabs/CardMetricLease.js